import api from '../token';

export const AddCompraFornecedor = async (dados) => {
  try {
    const response = await api.post('/AddCompraFornecedor', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};